import { Box, styled } from '@mui/material';

export const TipTapBarContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '2px',
  padding: '4px 8px',
  backgroundColor: '#f8f9fa',
});
